import { STORAGE_KEYS } from 'src/constants/'

const isSalesRep = () => {
    const sessionAccount: string = localStorage.getItem(STORAGE_KEYS.ACCOUNT) || ''
    const User = sessionAccount && JSON.parse(sessionAccount)
    return User && User.role.toLowerCase() !== 'customer'
}

export default isSalesRep



// WEBPACK FOOTER //
// ./src/helpers/isSalesRep/index.tsx